// SINGLE SOURCE OF TRUTH for all getdeparto product pricing.
// Change a price or validity here and the entire app picks it up:
//   - Booking page product cards
//   - Pay button
//   - Order summary
//   - Server-side amount verification (mirror this map in /app/backend/server.py)
//   - Confirmation + admin display

export const PRODUCT_CONFIG = {
  one_way_flight: {
    id: "one_way_flight",
    enabled: true,
    title: "One-way Flight Reservation",
    price: 599,
    currency: "INR",
    validityDays: 5,
    badge: null,
    bestFor: "Onward travel proof and short-term documentation",
    ctaLabel: "Select one-way",
    summaryLabel: "One-way flight reservation",
    requiresFlight: true,
    requiresReturnDate: false,
    requiresHotel: false,
    requiresMultiCityHotels: false,
  },

  return_flight: {
    id: "return_flight",
    enabled: true,
    title: "Return Flight Reservation",
    price: 899,
    currency: "INR",
    validityDays: 10,
    badge: "Most popular",
    bestFor: "Visa applications",
    ctaLabel: "Select return flight",
    summaryLabel: "Return flight reservation",
    requiresFlight: true,
    requiresReturnDate: true,
    requiresHotel: false,
    requiresMultiCityHotels: false,
  },

  hotel_single: {
    id: "hotel_single",
    enabled: true,
    title: "Hotel Reservation",
    price: 299,
    currency: "INR",
    validityDays: 10,
    badge: null,
    bestFor: "Accommodation proof",
    ctaLabel: "Select hotel",
    summaryLabel: "Hotel reservation",
    requiresFlight: false,
    requiresReturnDate: false,
    requiresHotel: true,
    requiresMultiCityHotels: false,
  },

  full_visa_pack: {
    id: "full_visa_pack",
    enabled: true,
    title: "Full Visa Pack",
    price: 1549,
    currency: "INR",
    validityDays: 10,
    badge: "Best value",
    bestFor: "Multi-city visa itineraries",
    includes: "Return flight reservation + multi-city hotels",
    ctaLabel: "Select Full Visa Pack",
    summaryLabel: "Full Visa Pack",
    requiresFlight: true,
    requiresReturnDate: true,
    requiresHotel: true,
    requiresMultiCityHotels: true,
  },
};

export const getEnabledProducts = () =>
  Object.values(PRODUCT_CONFIG).filter((p) => p.enabled);

export const getProductById = (productId) => PRODUCT_CONFIG[productId];

export const formatPrice = (price) => `₹${Number(price).toLocaleString("en-IN")}`;

// Compose the public order summary line based on a saved order or live form snapshot.
// Reads price + label + validity from the snapshot when present (so historic orders
// keep their original price even if the live config changes).
export function orderSummaryLine(order) {
  const snap = order?.product_snapshot || getProductById(order?.selected_product_id);
  if (!snap) return "";
  return `${snap.summaryLabel} · ${snap.validityDays}-day validity · ${formatPrice(
    order?.product_price ?? snap.price
  )}`;
}
